import React from 'react';

export default function Cart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 22 19"
    >
      <path
        fill="currentColor"
        d="M1.719.75H3.3a2 2 0 0 1 1.793 1.125h14.449c.914 0 1.582.879 1.336 1.793l-1.442 5.344c-.28 1.125-1.3 1.863-2.425 1.863H6.852l.21 1.02c.07.386.422.668.81.668h10.16c.456 0 .843.386.843.843a.833.833 0 0 1-.844.844H7.871c-1.195 0-2.25-.844-2.46-2.04l-1.83-9.525c-.035-.141-.14-.247-.281-.247H1.719c-.492 0-.844-.351-.844-.843 0-.457.352-.844.844-.844ZM5.48 3.563l1.055 5.624h10.477a.833.833 0 0 0 .808-.597l1.336-5.027H5.48ZM7.062 18.75c-.632 0-1.16-.316-1.476-.844-.316-.492-.316-1.16 0-1.687.316-.492.844-.844 1.476-.844.598 0 1.125.352 1.442.844.316.527.316 1.195 0 1.687-.316.528-.844.844-1.441.844Zm11.813-1.688c0 .633-.352 1.16-.844 1.477-.527.316-1.195.316-1.687 0a1.683 1.683 0 0 1-.844-1.477c0-.597.316-1.125.844-1.44.492-.317 1.16-.317 1.687 0 .492.316.844.843.844 1.44Z"
      />
    </svg>
  );
}
